import { InvoicingState } from "./types";
import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "./actions";

export type InvoicingAction = ActionType<typeof actions>;

const initialState: InvoicingState = {
  ui: {
    uploadInvoiceCSVModal: {
      isOpen: false,
      isPending: false,
      data: null,
      headers: {
        invoice_number: "",
        amount: "",
        invoice_date: "",
        due_date: "",
        client_name: "",
        client_email: "",
        client_phone_number: "",
        comments: "",
      },
    },
  },
  data: {
    invoices: { ids: [], byId: {} },
  },
};

const reducer = createReducer(initialState)
  .handleAction(actions.openInvoiceCSVModal, (state) => ({
    ...state,
    ui: {
      ...state.ui,
      uploadInvoiceCSVModal: {
        ...state.ui.uploadInvoiceCSVModal,
        isOpen: true,
      },
    },
  }))
  .handleAction(actions.cancelUploadInvoiceCSV, (state) => ({
    ...state,
    ui: {
      ...state.ui,
      uploadInvoiceCSVModal: {
        ...state.ui.uploadInvoiceCSVModal,
        isOpen: false,
        data: null,
        error: {},
        headers: { ...initialState.ui.uploadInvoiceCSVModal.headers },
      },
    },
  }))
  .handleAction(actions.selectInvoiceCSVHeaders, (state, { payload }) => {
    const existing = Object.entries(
      state.ui.uploadInvoiceCSVModal.headers
    ).find(([key, value]) => Object.values(payload).indexOf(value) > -1);
    return {
      ...state,
      ui: {
        ...state.ui,
        uploadInvoiceCSVModal: {
          ...state.ui.uploadInvoiceCSVModal,
          headers: {
            ...state.ui.uploadInvoiceCSVModal.headers,
            ...payload,
            ...(existing ? { [existing[0]]: "" } : {}),
          },
        },
      },
    };
  })
  .handleAction(actions.loadInvoiceCSVData, (state, { payload }) => ({
    ...state,
    ui: {
      ...state.ui,
      uploadInvoiceCSVModal: {
        ...state.ui.uploadInvoiceCSVModal,
        data: payload
          .filter((row) => !!row.length) // remove empty rows
          .filter((row) => row.find((col) => !!col)) // remove rows containing only empty strings
          .map((row: string[]) => row.map((cell) => String(cell).trim())),
        error: {},
        headers: { ...initialState.ui.uploadInvoiceCSVModal.headers },
      },
    },
  }))
  .handleAction(actions.unloadInvoiceCSVData, (state) => ({
    ...state,
    ui: {
      ...state.ui,
      uploadInvoiceCSVModal: {
        ...state.ui.uploadInvoiceCSVModal,
        data: null,
        error: {},
        headers: { ...initialState.ui.uploadInvoiceCSVModal.headers },
      },
    },
  }))
  .handleAction(actions.getInvoiceDataSuccess, (state, { payload }) => {
    return {
      ...state,
      data: {
        ...state.data,
        invoices: {
          ...state.data.invoices,
          ids: payload.map(({ id }) => id),
          byId: payload.reduce(
            (prev, next) => ({
              ...prev,
              [next.id]: next,
            }),
            {}
          ),
        },
      },
    };
  })
  .handleAction(actions.saveInvoiceCSVDataSuccess, (state, { payload }) => {
    return {
      ...state,
      data: {
        ...state.data,
        invoices: {
          ...state.data.invoices,
          ids: [...state.data.invoices.ids, ...payload.map(({ id }) => id)],
          byId: payload.reduce(
            (prev, next) => ({
              ...prev,
              [next.id]: next,
            }),
            state.data.invoices.byId
          ),
        },
      },
    };
  });

export { reducer as invoicingReducer };
